import React from 'react';
import { ReactComponent as NoticeIcon } from 'components/icons/notice.svg';
import { useInjection } from 'services/ioc/ioc.react';
import { UiStore } from 'stores/UiStore';
import { ServiceTypes } from 'constants/ServiceTypes';
import { Faq, Header, StyledRadarImage, Text, TextBox } from './DisconnectedPlaceholderStyles';

export const DisconnectedPlaceholder: React.FC = () => {
  const uiStore = useInjection<UiStore>(ServiceTypes.UiStore);
  return (
    <div>
      <Header>
        <Text>Disconnected</Text>
        <NoticeIcon />
      </Header>
      <div>
        <StyledRadarImage />
      </div>
      <TextBox>
        For help connecting please see the <br />
        <Faq onClick={() => uiStore.setIsFaqModalVisible(true)}>FAQ</Faq> or call
        <br /> (480)-757-7652
      </TextBox>
    </div>
  );
};
